import React, { Component } from 'react';
import $j from 'jquery';
import c from 'classnames';
import { Icon } from '@lyearn-team/frontend-components';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import windowSize from 'helper/WindowResize';
import Dotdotdot from 'react-dotdotdot';

const activeHeading = 'brand--color-acent blocks-tabs__header-item--active';
const activeSection = 'blocks-tabs__content-item--will-enter blocks-tabs__content-item--active';

@windowSize
class Tabs extends Component {
  state = {
    activeTab: 0,
    isHovered: false,
    width: NaN,
    widthBlock: NaN,
    showPreButton: false,
    showNextButton: false,
    lessonId: this.props.lesson.id
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lesson.id !== prevState.lessonId) {
      return {
        activeTab: 0,
        lessonId: nextProps.lesson.id
      };
    }
    return null;
  }

  componentDidMount() {
    this.resizeContainer = document.getElementsByClassName('blocks-tabs__header')[0];
    this.updateContainerDimensions();
    this.resizeEventListener = new ResizeSensor(
      this.resizeContainer,
      this.updateContainerDimensions
    );

    this.resizeBlock = document.getElementsByClassName('blocks-tabs__header-item')[0];
    this.updateBlockDimensions();
    this.resizeEventListenerBlock = new ResizeSensor(this.resizeBlock, this.updateBlockDimensions);
    this.handleScroll();
    this.resizeContainer.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.resizeEventListener.detach(this.resizeContainer);
    this.resizeEventListenerBlock.detach(this.resizeBlock);
    this.resizeContainer.removeEventListener('scroll', this.handleScroll);
    $j(this.htmlRef).off('click.external');
  }

  resizeContainer = null;
  widthBlock = null;

  handleScroll = () => {
    this.scrollPosition = document.getElementsByClassName('blocks-tabs__header')[0].scrollLeft;
    if (this.scrollPosition > 0) {
      this.setState({ showPreButton: true });
    } else {
      this.setState({ showPreButton: false });
    }
    const tabsHeader = $j('.blocks-tabs__header');
    if (tabsHeader[0].scrollWidth < tabsHeader.scrollLeft() + tabsHeader.width() + 10) {
      this.setState({ showNextButton: false });
    } else {
      this.setState({ showNextButton: true });
    }
  };

  updateContainerDimensions = () => {
    this.setState({ width: this.resizeContainer.offsetWidth });
  };

  updateBlockDimensions = () => {
    this.setState({ widthBlock: this.resizeBlock.offsetWidth });
  };

  setHtmlRef = (ref) => {
    this.htmlRef = ref;
    $j(this.htmlRef).off('click.external');
    $j(this.htmlRef).on('click.external', 'a', (e) => {
      e.preventDefault();
      window.open(e.currentTarget.getAttribute('href'));
    });
  };

  activeSection = index => () => {
    this.setState({
      activeTab: index
    });
  };

  handleHover = () => {
    this.setState(prevState => ({ isHovered: !prevState.isHovered }));
    this.scrollPosition = document.getElementsByClassName('blocks-tabs__header')[0].scrollLeft;
    if (this.scrollPosition > 0) {
      this.setState({ showPreButton: true });
    } else {
      this.setState({ showPreButton: false });
    }

    const tabsHeader = $j('.blocks-tabs__header');
    if (tabsHeader[0].scrollWidth < tabsHeader.scrollLeft() + tabsHeader.width() + 10) {
      this.setState({ showNextButton: false });
    } else {
      this.setState({ showNextButton: true });
    }
  };

  scrollDivLeft = () => {
    const tabsHeader = $j('.blocks-tabs__header');
    tabsHeader.animate(
      {
        scrollLeft: tabsHeader.scrollLeft() - this.state.width
      },
      'slow'
    );
  };

  scrollDivRight = () => {
    const tabsHeader = $j('.blocks-tabs__header');
    $j('.blocks-tabs__header').animate(
      {
        scrollLeft: this.state.width - 30 + tabsHeader.scrollLeft()
      },
      'slow'
    );
  };

  render() {
    const items = this.props.lesson.items;
    const editable = this.props.editable;
    const nextPreClass = this.state.isHovered
      ? 'blocks-tabs__header-wrap mouse'
      : 'blocks-tabs__header-wrap';
    const totalTabs = this.props.lesson.items.length;

    if (this.props.lesson.items.length <= this.state.activeTab) {
      this.state.activeTab = this.props.lesson.items.length - 1;
    }

    if (this.state.widthBlock * totalTabs >= this.state.width + 5) {
      if (this.state.showPreButton) {
        this.nextPreDisplayClass = 'blocks-tabs__controls end';
        this.preClass = 'blocks-tabs__arrow blocks-tabs__arrow--prev brand--background-acent';
      } else {
        this.nextPreDisplayClass = 'blocks-tabs__controls';
        this.preClass = 'blocks-tabs__arrow blocks-tabs__arrow--prev brand--background-acent hidden';
      }
      if (this.state.showNextButton) {
        this.nextPreDisplayClass = 'blocks-tabs__controls start';
        this.nextClass = 'blocks-tabs__arrow blocks-tabs__arrow--next brand--background-acent';
      } else {
        this.nextPreDisplayClass = 'blocks-tabs__controls';
        this.nextClass = 'blocks-tabs__arrow blocks-tabs__arrow--next brand--background-acent hidden';
      }
    } else {
      this.nextPreDisplayClass = 'blocks-tabs__controls start end';
      this.nextClass = 'blocks-tabs__arrow blocks-tabs__arrow--next brand--background-acent hidden';
      this.preClass = 'blocks-tabs__arrow blocks-tabs__arrow--prev brand--background-acent hidden';
    }

    return (
      <div className="block__content">
        <div className="blocks-tabs" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
          <div className="blocks-tabs__container">
            <div className="blocks-tabs__row">
              <div className="blocks-tabs__col">
                <div aria-label="Tab" className="blocks-tabs__wrapper">
                  <div
                    className={nextPreClass}
                    onMouseEnter={this.handleHover}
                    onMouseLeave={this.handleHover}
                  >
                    <div className="blocks-tabs__header" id="tabsheader" role="tablist">
                      {items.map((item, index) => (
                        <div
                          className={
                            'blocks-tabs__header-item brand--head '
                            + (this.state.activeTab === index ? activeHeading : '')
                          }
                          id="item-header-0"
                          role="tab"
                          style={{ cursor: 'pointer' }}
                          tabIndex="-1"
                          key={index}
                          onClick={this.activeSection(index)}
                        >
                          <span><Dotdotdot clamp={3}>{item.heading}</Dotdotdot></span>
                        </div>
                      ))}
                    </div>

                    <div className={this.nextPreDisplayClass}>
                      <div
                        className={this.preClass}
                        role="button"
                        tabIndex="-1"
                        onClick={this.scrollDivLeft}
                      >
                        <Icon type="angle-left" style={{ fill: '#ffffff' }} />
                      </div>
                      <div
                        className={this.nextClass}
                        role="button"
                        tabIndex="-1"
                        onClick={this.scrollDivRight}
                      >
                        <Icon type="angle-right" style={{ fill: '#ffffff' }} />
                      </div>
                    </div>
                  </div>

                  <div className="blocks-tabs__content">
                    {items.map((item, index) => (
                      <div
                        className={
                          'blocks-tabs__content-item '
                          + (this.state.activeTab === index ? activeSection : '')
                        }
                        id="item-cjp3nb1z000083h60am4vzxpi"
                        key={index}
                        role="tabpanel"
                        aria-labelledby="item-header-0"
                      >
                        <div className="brand--linkColor blocks-tabs__description brand--body brand--linkColor">
                          <div className="fr-box fr-inline" role="application">
                            <div className="fr-wrapper" dir="auto">
                              <div className="fr-element fr-view" dir="auto">
                                <div
                                  className={c('redactor-container', {
                                    editable,
                                    preview: !editable
                                  })}
                                  style={{ paddingTop: '0px', paddingBottom: '0px' }}
                                >
                                  <div
                                    ref={this.setHtmlRef}
                                    className="redactor-styles redactor-in htmlFamilyContainer"
                                    dangerouslySetInnerHTML={{ __html: item.html }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tabs;
